(function () {
  function initPrimoHome(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-hm-menu]').forEach(function (header) {
      if (header.dataset.hmReady === 'true') return;
      header.dataset.hmReady = 'true';
      var button = header.querySelector('[data-hm-menu-button]');
      var menu = header.querySelector('[data-hm-mobile-nav]');
      if (!button || !menu) return;
      button.addEventListener('click', function () {
        var open = header.classList.toggle('is-menu-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      menu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          header.classList.remove('is-menu-open');
          button.setAttribute('aria-expanded', 'false');
        });
      });
    });

    root.querySelectorAll('[data-hm-accordion]').forEach(function (accordion) {
      if (accordion.dataset.hmReady === 'true') return;
      accordion.dataset.hmReady = 'true';
      accordion.querySelectorAll('details').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          accordion.querySelectorAll('details').forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });

    var items = root.querySelectorAll('.hm-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries, instance) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        instance.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (item) { observer.observe(item); });
  }

  document.addEventListener('DOMContentLoaded', function () { initPrimoHome(document); });
  document.addEventListener('shopify:section:load', function (event) { initPrimoHome(event.target); });
})();
